import { Controller } from "@hotwired/stimulus"

// Drag-and-drop reordering of eligible staff in the admin shift panel.
// Sends the new staff_member_ids order to PATCH urlValue. Server re-renders
// the eligibility turbo-frame; controller swaps the frame's contents.
export default class extends Controller {
  static targets = ["item", "badge"]
  static values = { url: String, shiftId: Number }

  dragStart(event) {
    this.dragged = event.currentTarget
    event.dataTransfer.effectAllowed = "move"
    try { event.dataTransfer.setData("text/plain", event.currentTarget.dataset.staffMemberId || "") } catch (_) {}
    event.currentTarget.classList.add("opacity-50")
  }

  dragOver(event) {
    event.preventDefault()
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move"
  }

  drop(event) {
    event.preventDefault()
    const target = event.currentTarget
    if (!this.dragged || target === this.dragged) return

    const rect = target.getBoundingClientRect()
    const after = event.clientY > rect.top + rect.height / 2
    target.parentNode.insertBefore(this.dragged, after ? target.nextSibling : target)

    this.renumberBadges()
    this.persist()
  }

  dragEnd(event) {
    event.currentTarget.classList.remove("opacity-50")
    this.dragged = null
  }

  renumberBadges() {
    this.itemTargets.forEach((item, index) => {
      const badge = item.querySelector('[data-priority-dnd-target="badge"]')
      if (!badge) return
      badge.textContent = index + 1
      badge.classList.remove("bg-gray-200", "text-gray-500")
      badge.classList.add("bg-indigo-500", "text-white")
    })
  }

  async persist() {
    const ids = this.itemTargets.map(el => el.dataset.staffMemberId).filter(Boolean)
    if (ids.length === 0) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    ids.forEach(id => formData.append("staff_member_ids[]", id))

    let response
    try {
      response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": csrfToken || "",
          "Accept": "text/html"
        },
        body: formData
      })
    } catch (err) {
      console.error("Priority reorder request failed:", err)
      return
    }

    if (response.status === 409) {
      alert("Een andere gebruiker heeft de volgorde net aangepast. Herlaad om de huidige status te zien.")
      window.location.reload()
      return
    }

    if (!response.ok) {
      console.error("Priority reorder failed:", response.status)
      return
    }

    const html = await response.text()
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
    const frameId = `shift_${this.shiftIdValue}_eligibility`
    const newFrame = doc.querySelector(`turbo-frame[id="${frameId}"]`)
    const existingFrame = document.querySelector(`turbo-frame[id="${frameId}"]`)
    if (newFrame && existingFrame) {
      existingFrame.innerHTML = newFrame.innerHTML
    }
  }
}
